"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Calendar = _interopRequireDefault(require("../Calendar"));
var _DatePicker = require("./DatePicker.utils");
var _Calendar2 = require("../Calendar/Calendar.utils");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _appendCss = _interopRequireDefault(require("../../utils/appendCss"));
var _getLanguage = _interopRequireDefault(require("../../utils/getLanguage"));
var _DatePicker_css = _interopRequireDefault(require("./DatePicker_css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class DatePicker extends _react.Component {
  constructor(props) {
    super(props);
    (0, _appendCss.default)("arc_dtpkr", _DatePicker_css.default);
    this.language = (0, _getLanguage.default)();
    this.formatDates = this.formatDates.bind(this);
    const updatedDates = this.formatDates(props);
    this.state = {
      ...updatedDates,
      dateHovered: null,
      isRange: this.props.isRange,
      visibleDates: (0, _DatePicker.getDatesInView)({
        ...this.props,
        dateHovered: null,
        ...updatedDates
      }),
      daysInRange: this.props.daysInRange
    };
    this.clickCalendarIncrementor = this.clickCalendarIncrementor.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.hoverOffDate = this.hoverOffDate.bind(this);
    this.hoverSelectDate = this.hoverSelectDate.bind(this);
    this.selectDate = this.selectDate.bind(this);
  }
  formatDates(props) {
    const {
      focusDate,
      datesChosen,
      minDate,
      maxDate,
      blackoutDates
    } = props;
    const _focusDate = focusDate || datesChosen[0] ? (0, _dayjs.default)(focusDate || datesChosen[0]) : undefined;
    const _datesChosen = [null];
    if (datesChosen[0]) _datesChosen[0] = (0, _dayjs.default)(datesChosen[0]);
    if (datesChosen[1]) _datesChosen[1] = (0, _dayjs.default)(datesChosen[1]);
    const _minDate = minDate ? (0, _dayjs.default)(minDate) : undefined;
    const _maxDate = maxDate ? (0, _dayjs.default)(maxDate) : undefined;
    const _blackoutDates = blackoutDates ? blackoutDates.map(date => (0, _dayjs.default)(date)) : null;
    return {
      focusDate: _focusDate,
      datesChosen: _datesChosen,
      minDate: _minDate,
      maxDate: _maxDate,
      blackoutDates: _blackoutDates
    };
  }
  updateDates(props) {
    const updatedDates = this.formatDates(props);
    this.setState({
      visibleDates: (0, _DatePicker.getDatesInView)({
        ...props,
        ...updatedDates
      }),
      ...updatedDates
    });
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.dateHovered !== nextState.dateHovered || this.state.datesChosen !== nextState.datesChosen || this.state.focusDate !== nextState.focusDate || this.props.showCalendar !== nextProps.showCalendar || this.props.blackoutDates !== nextProps.blackoutDates || this.props.isOpen !== nextProps.isOpen || this.props.isLoading !== nextProps.isLoading) {
      return true;
    }
    return false;
  }
  componentDidMount() {
    this.updateDates(this.props);
  }
  componentDidUpdate(prevProps) {
    if (this.props.showCalendar) {
      document.addEventListener("click", this.handleClickOutside);
    } else {
      document.removeEventListener("click", this.handleClickOutside);
    }
    // Redraw dates if the blackout date prop changes
    if (this.props.blackoutDates !== prevProps.blackoutDates) {
      this.forceUpdate();
      this.updateDates(this.props);
    }
  }
  clickCalendarIncrementor(direction) {
    const newFocusDate = (0, _DatePicker.getIncrementedFocusDate)(this.state.focusDate, direction);
    const newVisibleDates = (0, _DatePicker.getDatesInView)({
      ...this.getStateForUtils(),
      focusDate: newFocusDate,
      minDate: this.state.minDate
    });
    this.setState({
      focusDate: newFocusDate,
      visibleDates: newVisibleDates
    });
    if (this.props.onMonthChange) {
      this.props.onMonthChange(newFocusDate.format("YYYY-MM-DD"));
    }
  }
  getStateForUtils() {
    let focusDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.focusDate;
    const result = {
      ...this.props,
      ...this.state,
      focusDate
    };
    return result;
  }
  handleClickOutside(event) {
    if (this.dropdownElement && !this.dropdownElement.contains(event.target) && this.props.closeDatePicker) {
      this.props.closeDatePicker();
    }
  }
  hoverOffDate() {
    this.setState({
      dateHovered: null,
      visibleDates: (0, _DatePicker.getDatesInView)({
        ...this.getStateForUtils(),
        dateHovered: null
      })
    });
  }
  hoverSelectDate(date) {
    if ((0, _Calendar2.isDayDisabled)(date, this.getStateForUtils())) {
      return;
    }
    this.setState({
      dateHovered: date,
      visibleDates: (0, _DatePicker.getDatesInView)({
        ...this.getStateForUtils(),
        dateHovered: date,
        datesChosen: this.state.datesChosen
      })
    });
  }
  selectDate(date) {
    const nextDatesChosen = (0, _DatePicker.updateDatesChosen)(date, this.state);
    const nextDateHovered = null;
    this.setState({
      datesChosen: nextDatesChosen,
      dateHovered: nextDateHovered,
      visibleDates: (0, _DatePicker.getDatesInView)({
        ...this.getStateForUtils(),
        datesChosen: nextDatesChosen,
        dateHovered: nextDateHovered
      })
    });
    if (this.props.onChange && typeof this.props.onChange === "function") {
      this.props.onChange(nextDatesChosen);
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "DatePicker"
    }, !this.props.isOpen ? null : /*#__PURE__*/_react.default.createElement("div", {
      ref: node => this.dropdownElement = node,
      className: (0, _classnames.default)({
        "DatePicker-dropdown": true,
        "is-singleCalendarOnly": this.props.numberOfCalendars === 1
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "DatePicker-calendars"
    }, this.state.visibleDates.map((month, index) => /*#__PURE__*/_react.default.createElement(_Calendar.default, {
      index: index,
      key: `cal-pkr-${index}`,
      state: this.getStateForUtils(month[0][6].date),
      month: this.state.visibleDates[index],
      clickCalendarIncrementor: this.clickCalendarIncrementor,
      clickSelectDate: this.selectDate,
      hoverSelectDate: this.hoverSelectDate,
      hoverOffDate: this.hoverOffDate,
      numberOfCalendars: this.props.numberOfCalendars,
      themeColor: this.props.themeColor,
      language: this.language,
      isLoading: this.props.isLoading,
      showIndicators: {
        prev: (0, _DatePicker.shouldShowPrevIndicator)(this.state.focusDate, this.state.minDate),
        next: (0, _DatePicker.shouldShowNextIndicator)(this.state.focusDate, this.state.maxDate, this.props.numberOfCalendars)
      }
    })))));
  }
}

// NOTICE: When adding new props, make sure to add them to state in the constructor
exports.default = DatePicker;
DatePicker.propTypes = {
  /** The currently selected date(s).. or date(s) to start with */
  datesChosen: _propTypes.default.array.isRequired,
  /** Array of dates to be marked as disabled (non-interactive) formatted in YYYY-MM-DD */
  blackoutDates: _propTypes.default.array,
  /** Is the picker open or not */
  isOpen: _propTypes.default.bool.isRequired,
  /** A callback function called as the user selects dates  */
  onChange: _propTypes.default.func.isRequired,
  /** A callback function called as the user changes the calendar month  */
  onMonthChange: _propTypes.default.func,
  /** Shows a loading UI and prevents interaction with the calendar */
  isLoading: _propTypes.default.bool,
  /** Date to guarantee is visible the first time the date picker opens */
  focusDate: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  /** Allow user to select a date range.. like a start and end date */
  isRange: _propTypes.default.bool,
  /** Earliest day available */
  minDate: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  /** Latest day available, will auto-adjust to 20 days after start date in range */
  maxDate: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  /** Number of calendars simultaneously visible */
  numberOfCalendars: _propTypes.default.number,
  /** Theme color variant [primary, accent, error, success] */
  themeColor: _propTypes.default.oneOf(["primary", "accent", "error", "success"]),
  /** Days the user can select from start date */
  daysInRange: _propTypes.default.number
};
DatePicker.defaultProps = {
  isRange: false,
  isLoading: false,
  numberOfCalendars: 1,
  themeColor: "primary",
  daysInRange: 21,
  blackoutDates: null,
  onMonthChange: null
};